import { useMapEvents } from 'react-leaflet';

export default function MouseCoords({ onHover }) {
  useMapEvents({
    mousemove(e) {
      const { lat, lng } = e.latlng;
      onHover({ x: lng, y: lat });
    },
    mouseout() {
      onHover(null);
    }
  });
  return null;
}
